<template>
    <!--dubblebox-->
    <div>
        <div class="" v-if="gspn_yn === 'Y'">
            <div v-if="imei_pw.length > 0" style="font-size: 1.2em; font-weight: bold;">
                Current IMEI OTP Password:
                <div
                    style="display: inline-block; padding: 4px; border: 3px solid blue; font-size: 1.3em;">
                    {{imei_pw}}
                </div>
                <br>
                    Time Remaining(hh:mm:ss)
                <br>
                <span class="txt_warning">{{valid_time}}</span>
            </div>
            <p style="font-size: 1.1em;">
                Lost or want to change the IMEI OTP Password?
                <a
                    href="javascript:"
                    class="btn_white"
                    @click="onReissueClick"
                >Reissue</a>
            </p>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import { SDLUtil, DateUtil, CertUtil } from '@/utils';

import qs from 'query-string';
import { EventBus } from '@/utils/EventBus';

export default {
    name: 'hhp-login-success',
    components: {},
    props: [],
    data() {
        return {
            imei_pw: '',
            imei_pw_masking: '',

            otp_update_yn: '',
            gspn_yn: '',
            use_yn: '',
            valid_time: '',

            nsdReturnCode: '',
        };
    },
    computed: {},

    created() {
        this.init();
    },
    mounted() {},

    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchInitData(false)
                .catch(err => {
                    if (err.data.error.code === 'REDIRECT') {
                        SDLUtil.alert({
                            title: 'IMEI Password Update',
                            msg: 'IMEI Password needs to be updated. Please update the password.',
                            onOkEvt: () => {
                                this.$router.push({name: 'requestImeiPwdUpdate'});
                            },
                        });
                    }
                });
            SDLUtil.showLoadingBar(false);
            this.setData(data);
        },

        fetchInitData(otpUpdate) {
            if (otpUpdate === true) otpUpdate = 'Y';
            if (otpUpdate === false) otpUpdate = 'N';

            const path = '/basis/certificate/CertLoginSuccess.skp';
            return SDLUtil.getRequest(path, {
                otp_update_yn: otpUpdate,
            });
        },

        setData(data) {
            this.otp_update_yn = data.otp_update_yn || 'N';
            this.gspn_yn = data.gspn_yn;
            this.use_yn = data.use_yn || 'N';
            // alert('useYN: ' + this.use_yn);
            if (this.use_yn === 'Y') {
                this.imei_pw = data.imei_pw || data.imei_pw_masking;
            } else {
                this.imei_pw = data.imei_pw_masking || '';
            }
            // this.imei_pw = data.imei_pw || data.imei_pw_masking || '';
            // this.imei_pw_masking = data.imei_pw_masking || '';
            this.valid_time = data.valid_time || '';
            this.nsdReturnCode = data.nsdReturnCode;
        },

        async onReissueClick() {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchInitData(true);
            SDLUtil.showLoadingBar(false);
            this.setData(data);
        },

        onContinueClick() {
            const path = localStorage.getItem('hhp_redirect');
            if (path) {
                localStorage.removeItem('hhp_redirect');
                this.$router.push({ path });
            } else {
                this.$router.push({ name: 'hhpServiceBulletin' });
            }
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/certificate/CertOTP.vue